/** Subscribes to the live dashboard WebSocket feed (node health + calls). */

import { useEffect, useState } from "react";
import { openDashboardFeed } from "@pbxmgr/api";
import type { DashboardLive } from "@pbxmgr/api";

export interface LiveState {
  live: DashboardLive | null;
  connected: boolean;
  /** Epoch ms of the last live frame — drives the staleness indicator. */
  lastFrameAt: number;
}

/** Opens the feed on mount and returns the latest payload + connection state. */
export function useDashboardLive(): LiveState {
  const [live, setLive] = useState<DashboardLive | null>(null);
  const [connected, setConnected] = useState(false);
  const [lastFrameAt, setLastFrameAt] = useState(0);
  useEffect(
    () =>
      openDashboardFeed({
        onLive: (payload) => {
          setLive(payload);
          setLastFrameAt(Date.now());
        },
        onStatus: setConnected,
      }),
    [],
  );
  return { live, connected, lastFrameAt };
}
